import { Controller } from "@hotwired/stimulus"

/** Shows/hides schedule sub-fields based on assign_mode radio and schedule_interval select. */
export default class extends Controller {
  static targets = ["timeRow", "weeklyRow", "monthlyRow", "yearlyRow", "scheduleBox", "assignMode"]

  connect() {
    this._onChange = () => this.toggle()
    this.selectEl = this.element.querySelector("select[name*='schedule_interval']")
    if (this.selectEl) {
      this.selectEl.addEventListener("change", this._onChange)
    }
    this.toggle()
  }

  disconnect() {
    if (this.selectEl) {
      this.selectEl.removeEventListener("change", this._onChange)
    }
  }

  toggle() {
    const scheduled = this._assignMode() === "scheduled"
    if (this.hasScheduleBoxTarget) {
      this.scheduleBoxTarget.classList.toggle("is-hidden", !scheduled)
    }
    const v = this.selectEl?.value || ""
    const hasSchedule = scheduled && v !== ""
    if (this.hasTimeRowTarget) this._hide(this.timeRowTarget, !hasSchedule)
    if (this.hasWeeklyRowTarget) this._hide(this.weeklyRowTarget, v !== "weekly")
    if (this.hasMonthlyRowTarget) this._hide(this.monthlyRowTarget, !["monthly", "quarterly", "yearly"].includes(v))
    if (this.hasYearlyRowTarget) this._hide(this.yearlyRowTarget, v !== "yearly")
  }

  _assignMode() {
    if (this.hasAssignModeTarget) {
      const checked = this.assignModeTargets.find((el) => el.checked)
      if (checked) return checked.value
    }
    return this.selectEl?.value ? "scheduled" : "manual"
  }

  _hide(el, hidden) {
    if (!el) return
    el.classList.toggle("is-hidden", hidden)
  }
}
